import { useState } from 'react';
import styles from './LeaveDetails.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import CalendarInput from '../../components/CalendarInput/CalendarInput';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import { BsPersonFillCheck } from 'react-icons/bs';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';

const LeaveDetails = () => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSetRange = () => {
    console.log('Set Range:', { fromDate, toDate });
  };

  const handleCancel = () => {
    setFromDate('');
    setToDate('');
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon icon={<BsPersonFillCheck />} heading="Leave Details" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.body}>
        <div className={styles.dateRow}>
          <CalendarInput
            fieldLabel="From"
            label="Choose from date"
            required={true}
            value={fromDate}
            onChange={(val) => setFromDate(val)}
          />
          <HeadingAndData label={'Days'} placeholder={'Enter Days'} />
        </div>
        <div className={styles.dateRow}>
          <CalendarInput
            fieldLabel="To"
            label="Choose from date"
            required={true}
            value={fromDate}
            onChange={(val) => setToDate(val)}
          />
          <HeadingAndData label={'Type'} placeholder={'Enter Type'} />
        </div>
        <div className={styles.new}>
          <label>Reason</label>
          <textarea value={'-'} readOnly />
        </div>

        <SaveAndCancel
          cancelLabel="Cancel"
          saveLabel="Set Range"
          onCancel={handleCancel}
          onSave={handleSetRange}
        />
      </div>
    </div>
  );
};

export default LeaveDetails;
